<app-section-loader [loading]="loading"></app-section-loader>
<div class="mContent__header bg-primary py-3 px-5"
    [ngClass]="{'pb-4': (availableSchools?.length === 1 && reportForm.get('district').value) || (tutorList?.length === 1 && selectedSchool?.id !== 0 && selectedSchool)}">
    <h1 class="text-white mb-1">Reports - Tutors</h1>
    <form [formGroup]="reportForm">
        <div class="mControls">
            <div class="input-group">
                <mat-form-field appearance="outline" class="input-white no-error">
                    <mat-label>School District</mat-label>
                    <mat-select formControlName="district" (selectionChange)="districtSelected($event)">
                        <mat-option *ngFor="let district of allDistricts" [value]="district.id">
                            {{district.district_name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="input-group" style="position: relative;">
                <mat-form-field appearance="outline" class="input-white no-error">
                    <mat-label>School</mat-label>
                    <mat-select formControlName="school" (selectionChange)="schoolSelected($event)">
                        <mat-option *ngFor="let school of availableSchools" [value]="school.id">
                            {{school.school_name}} {{school.uuid?"("+school.uuid+")":''}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="text-danger w-100 dropdown_custommsg"
                    *ngIf="availableSchools?.length === 1 && reportForm.get('district').value">
                    No schools available in this district
                </div>
            </div>
            <div class="input-group" style="position: relative;">
                <mat-form-field appearance="outline" class="input-white no-error">
                    <mat-label>Tutor</mat-label>
                    <mat-select formControlName="tutor" (selectionChange)="tutorSelected($event)">
                        <mat-option *ngFor="let tutor of tutorList" [value]="tutor.id">
                            {{tutor.tutor_name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="text-danger w-100 dropdown_custommsg"
                    *ngIf="tutorList?.length === 1 && selectedSchool?.id !== 0 && selectedSchool">
                    No tutors available for the selected school
                </div>
            </div>
            <div class="input-group">
                <mat-form-field appearance="outline" class="input-white no-error">
                    <mat-label>School Year</mat-label>
                    <mat-select formControlName="school_year" (selectionChange)="yearSelected()">
                        <mat-option *ngFor="let year of schoolYears" [value]="year">
                            {{year}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="input-group mr-auto">
                <button (click)="renderReport(reportForm.getRawValue())" mat-raised-button [disabled]="!reportForm.valid || noSchoolsAvailable || noTutorsAvailable">
                    <mat-icon>play_arrow</mat-icon> Run Report
                </button>
            </div>
            <div class="mControls__right">
                <div class="input-group">
                    <button mat-raised-button [disabled]="!reportLoaded" (click)="exportAllReports()">
                        <mat-icon>publish</mat-icon> Export Report
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="scroll flex-fill overflow-auto py-3 px-5" *ngIf="filtersSelected && reportLoaded">
    <div class="container p-0 h-100">
        <div class="d-flex flex-column h-100 tab-group-area">
            <div class="overflow-auto">
                <div class="row mx-0 mt-4" id='allCharts'>
                    <div class="col-lg-6 px-2 mb-3" *ngIf="selectedTutor.id !== 0">
                        <div class="card h-100">
                            <div class="card-body">
                                <div *ngIf="selectedReport">
                                    <button mat-raised-button color="primary" class="on-hover-showbtn" (click)="exportIndividualReport('tutorsessions')">EXPORT</button>
                                    <div id='tutorSessionReport'>
                                        <p style="margin: 0;">{{ sessionTitle }}</p>
                                        <p style="margin: 0;">{{ selectedTutor.tutor_name }}</p>
                                        <div style="margin: 0;">{{ selectedYear !== 'All Years' ? selectedYear : 'All School Years' }}</div>
                                        <div class="mt-2">
                                            <h3>Schools and Assigned Students:</h3>
                                        </div>
                                        <div class="mt-3">
                                            <div *ngFor="let school of tutorSchools">
                                                <h6>
                                                    <p style="color:blue; size:20px; font-size: 20px;">
                                                        {{ school.school_name }}
                                                    </p>
                                                </h6>
                                                <div *ngFor="let student of school.student_list">
                                                    <p style="margin: 0;" class="student-name-font">{{ student |
                                                        titlecase}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3" style="text-align:center" *ngIf="tutorSchools.length === 0">
                                            <h5><em>Tutor has not been assigned any students</em></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 px-2 mb-3" *ngIf="selectedTutor.id === 0">
                        <div class="card h-100">
                            <div class="card-body">
                                <div *ngIf="selectedReport">
                                    <button mat-raised-button color="primary" class="on-hover-showbtn" (click)="exportIndividualReport('count')">EXPORT</button>
                                    <div id='donutReport'>
                                        <app-double-donut-chart [title]="tutorCountTitle" [subTitle]="subTitleDonut"
                                            [chartData]="reportData?.data" [extraData]="reportData?.extraData"></app-double-donut-chart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 px-2 mb-3">
                        <div class="card h-100">
                            <div class="card-body">
                                <div *ngIf="selectedReport">
                                    <button mat-raised-button color="primary" class="on-hover-showbtn" (click)="exportIndividualReport('sessions')">EXPORT</button>
                                    <div id='sessionReport'>
                                        <app-tutor-session-report [title]="sessionTitle" [subTitles]="sessionSubTitles"
                                            [sessionData]="reportData?.sessions"></app-tutor-session-report>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="flex-fill d-flex" *ngIf="!filtersSelected">
    <div class="m-auto">
        <img src="assets/images/no-result.png" alt="">
        <h2 class="text-center">Select filters and run a report</h2>
    </div>
</div>

<div class="flex-fill d-flex" *ngIf="filtersSelected && !reportLoaded">
    <div class="m-auto">
        <img src="assets/images/no-result.png" alt="">
        <h2 class="text-center">Click on "Run Report" to render the new report</h2>
    </div>
</div>